import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

export const ProductCard = (props) => {
  const navigate = useNavigate();



  const onToast = () => {
    toast.success('Added to cart!', {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      });
  }
  const handalClick = (id) => {
    navigate(`/product/${id}`);
  };

  const handalCart = async () => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/cart/addproduct`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            productId: props.id,
            quantity: 1,
          }),
        }
      );

      if (res.status === 200) {
        onToast();
        await res.json();
      } else if (res.status === 401) {
        sessionStorage.removeItem("token");
        navigate("/login");
      } else {
        console.error("Failed to add product to cart. Status:", res.status);
      }
    } catch (err) {
      console.error("Network error when adding to cart:", err);
    }
  };
  return (
    <>
      <li>
        <div className="product-card">
          <figure className="card-banner">
            <img
              // src="./images/product-1.png"
                src={
                  props.id === 1
                      ? "/images/product-1.png"
                      : props.id === 2
                          ? "/images/product-2.png"
                          : props.id === 3
                              ? "/images/product-3.png"
                              : "/images/product-4.png"
                }
              // src={base64Image}

              width={189}
              height={189}
              loading="lazy"
              alt="Fresh Orangey"
            />
            <div className="btn-wrapper">
              <button className="product-btn" aria-label="Add to Whishlist">
                <ion-icon name="heart-outline" />
                <div className="tooltip">Add to Whishlist</div>
              </button>
              <button
                className="product-btn"
                onClick={() => handalClick(props.id)}
                aria-label="Quick View"
              >
                <ion-icon name="eye-outline" />
                <div className="tooltip">Quick View</div>
              </button>
            </div>
          </figure>
          <div className="rating-wrapper">
            <ion-icon name="star" />
            <ion-icon name="star" />
            <ion-icon name="star" />
            <ion-icon name="star" />
            <ion-icon name="star" />
          </div>
          <h3 className="h4 card-title">
            <a href="/product/1">{props.name}</a>
          </h3>
          <div className="price-wrapper">
            <del className="del">Rs {props.price+100}</del>
            <data className="price" value={85.0}>
              Rs {props.price}
            </data>
          </div>
          <button className="btn btn-primary" onClick={() => handalCart()}>
            Add to Cart
          </button>
        </div>
      </li>

    </>
  );
};
